import React, { useEffect } from 'react';
import Echo from 'laravel-echo';
import Pusher from 'pusher-js';

const SimplePusherListener = () => {
    useEffect(() => {
        // Set up Pusher client
        const pusher = new Pusher('c8abb1aa44569363aaf0', {
            cluster: 'us2',
            encrypted: true
        });

        // Subscribe to the 'autogen' channel
        const channel = pusher.subscribe('autogen');

        // Listen for the 'NewAutogenMessage' event
        channel.bind('NewAutogenMessage', function(data) {
            console.log('Received NewAutogenMessage:', data.message); // Log the received message
        });

        // Subscription success
        channel.bind('pusher:subscription_succeeded', function() {
            console.log('Subscription to channel succeeded');
        });

        // Subscription error
        channel.bind('pusher:subscription_error', function(status) {
            console.error('Subscription error:', status);
        });

        // Cleanup on unmount
        return () => {
            pusher.unsubscribe('autogen');
        };
    }, []);

    return (
        <div>
            <h1>Listening to Pusher Channel</h1>
            <p>Check the console for received messages.</p>
        </div>
    );
};

export default SimplePusherListener;
